/**
 * Mobile nav: the burger toggles the link panel; choosing a link closes it.
 * Desktop is untouched (the burger is display:none there).
 */
export function initNav(): void {
  const burger = document.getElementById('navburger')
  const links = document.getElementById('navlinks')
  if (!burger || !links) return

  burger.addEventListener('click', () => {
    const open = links.classList.toggle('open')
    burger.setAttribute('aria-expanded', String(open))
  })

  links.addEventListener('click', (event) => {
    if (!(event.target as HTMLElement).closest('a')) return
    links.classList.remove('open')
    burger.setAttribute('aria-expanded', 'false')
  })
}
